import React from "react";
import { Box } from "@mui/material";
import { useClinicTheme } from "../../theme";

/**
 * Sayfa başlığında kullanılan gradient ikon kutusu (atom).
 * @param {React.ReactNode} icon - İkon (FaClinicMedical, ManageAccountsIcon vb.)
 * @param {number} size - Kutu boyutu (px), varsayılan 52
 */
export default function IconBox({ icon, size = 52 }) {
  const { palette } = useClinicTheme();
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: 3,
        background: `linear-gradient(135deg, ${palette.primary} 0%, ${palette.primaryDark} 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        flexShrink: 0,
        boxShadow: `0 10px 24px ${palette.primary}59`,
      }}
    >
      {icon}
    </Box>
  );
}
